'use client'
import type { FunctionComponent } from "react"
import useScrollRestorer from "./useScrollRestorer"
import { scrollRestoreConfig } from "./config"

interface ScrollRestorationProps {
    debug?: boolean
}

const ScrollRestoration: FunctionComponent<ScrollRestorationProps> = ({ debug }) => {
    if (debug !== undefined) {
        scrollRestoreConfig.debug = debug
    }
    useScrollRestorer()
    return <></>
}
export default ScrollRestoration
